document.querySelectorAll("div[id*='__ebfd8150-cc0e-4a42-b11e-6cd7ede1f4a0'] .card button").forEach((i, index) => {
	i.addEventListener("click", () => {
			document.querySelector("div[id*='__ebfd8150-cc0e-4a42-b11e-6cd7ede1f4a0'] > section > div > h2 + div").classList.toggle(`indexfaq${index}`)
	})
})


if(document.querySelector('.accountlogo') != null){
	document.querySelector('.accountlogo').addEventListener("click", () => {
	  window.location.href = `/account/login`;
	})
}

if(document.querySelector('div[id*="__e0761601-d810-4ce5-a230-4e098047903d"] form .submit') !== null){

document.querySelector('div[id*="__e0761601-d810-4ce5-a230-4e098047903d"] form .submit').addEventListener("click", () => {
	document.querySelector(".calendly-badge-content").click()
})

}

if(document.querySelector('.earlyadoptbanner') !== null) {
  document.querySelectorAll('.earlyadoptbanner').forEach((i) => {
    i.addEventListener("click", (e) => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'TD9A8d']);
    })
  })
}

if(document.querySelector('.limitedofferbtn') !== null) {
  document.querySelector('.limitedofferbtn').addEventListener("click", () => {
  	// document.querySelector(".calendly-badge-content").click()
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'SfnYnQ']);
  })
}

if(document.querySelector('.joinourbabyexpert') !== null){

document.querySelector('.joinourbabyexpert').addEventListener("click", () => {
	// document.querySelector(".calendly-badge-content").click()
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SfnYnQ']);
})

if(document.querySelector('.joinourbabyexpert2') !== null) {

document.querySelector('.joinourbabyexpert2').addEventListener("click", () => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SfnYnQ']);
})

}

document.querySelector('div[id*="__52d6bc6c-377b-4875-8b92-f3419657b4ea"] a').addEventListener("click", (e) => {
    e.preventDefault(); 
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SfnYnQ']);
})
  
document.querySelector('div[id*="__6e04382c-f77e-49b3-a000-462491589c5c"] li:last-child a').addEventListener("click", (e) => {
    e.preventDefault(); 
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SfnYnQ']);
})

}

if(document.querySelector("#shopify-section-footer .section-content > .grid > div li:nth-child(3)") !== null) {
   document.querySelector("#shopify-section-footer .section-content > .grid > div li:nth-child(3)").addEventListener("click", (e) => {
      e.preventDefault(); 
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'R86pU5']);
  })
}


if(document.querySelector("div[id*='__cf8f68d8-75eb-449e-b3ea-b9968f5ca31b'] ul li:last-child .card a") !== null) {
     document.querySelector("div[id*='__cf8f68d8-75eb-449e-b3ea-b9968f5ca31b'] ul li:last-child .card a").addEventListener("click", (e) => {
      e.preventDefault(); 
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'TD9A8d']);
  })
}

if(document.querySelector(".joinearlyadoptorfixed") !== null) {
     document.querySelector(".joinearlyadoptorfixed").addEventListener("click", (e) => {
      e.preventDefault(); 

       if(document.querySelector(".opensidecartx #cart") == null) {
			document.querySelector(".add-to-cart-btn").click();
		} else {
			document.querySelector("#CartButton").click();
		}
  })
}

const newwaitingbtn = document.createElement("button");
newwaitingbtn.innerText = "Pre-Order";
newwaitingbtn.classList.add("newwaitingbtn");
newwaitingbtn.addEventListener("click", () => {
        if(document.querySelector(".opensidecartx #cart") == null) {
			document.querySelector(".add-to-cart-btn").click();
		} else {
			document.querySelector("#CartButton").click();
		}
})

if(document.querySelector(".product-block-buy-buttons") !== null) {
  document.querySelector(".product-block-buy-buttons").append(newwaitingbtn)
}

if(document.querySelector('#facets-results') !== null) {
	
	let initpostnumber = 9;
	
	let loadmorebtnx = document.createElement("button");
	loadmorebtnx.innerText = "Load More";
	loadmorebtnx.classList.add("loadmorebtn");
	loadmorebtnx.addEventListener("click", () => {
		document.querySelectorAll('#facets-filterable li').forEach((i, index) => {
			
			if(index < initpostnumber){
				setTimeout(function() {
					i.style.setProperty("display", "block", "important")
				}, 300);
			}
		})
		
		initpostnumber += 3;
	})
	
	document.querySelector('#facets-results').append(loadmorebtnx)
	
	
}

if (window.location.href.indexOf("blogs") > -1) {

let nodeh1 = document.querySelector("body.article #MainContent > div[id*='__main'] h1");
let nodeh2 = document.querySelector("body.article #MainContent > div[id*='__main'] .rte h2");
let nodep = document.querySelector(" body.article #MainContent > div[id*='__main'] > section > div > div > div > div + p");
let cloneh1;
let cloneh2;
let clonep;


if(document.querySelector("body.article #MainContent > div[id*='__main'] h1") !== null) {
	

cloneh1 = nodeh1.cloneNode(true);
cloneh2 = nodeh2.cloneNode(true);
clonep = nodep.cloneNode(true);

let newdiv1 = document.createElement("div");
newdiv1.classList.add("postheadercontent");
newdiv1.append(cloneh1);
newdiv1.append(cloneh2);
newdiv1.append(clonep);

document.querySelector("body.article #MainContent > div[id*='__main'] > section > div > div >div > div").append(newdiv1);

}

}

if(document.querySelector(".blogsharebtn") !== null) {
  document.querySelector(".blogsharebtn").addEventListener("click", () => {
    document.querySelector(".blogsharebtn_contents").classList.toggle("showorhide");
  })
}

if(document.querySelector("body.Apply") !== null) {
  
document.querySelectorAll('div[id*="__5f422bc0-7058-41b0-a9f8-69725924cee3"] form div input:not(input[type="file"])').forEach((input) => {
input.addEventListener("blur", () => {
  if (!input.validity.valid) {
    input.style.border = "1.5px solid red";
    input.placeholder = input.validationMessage;
    input.value = "";
  } else {
    input.style.border = ""; // Remove red border if input is valid
  }
});
});

const dialog = document.getElementById("popupDialog");
const closeBtn = document.getElementById("closeDialog");

if (window.location.search.includes("contact_posted=true")) {
dialog.showModal();
}

closeBtn.addEventListener("click", function() {
dialog.close();
history.replaceState(null, "", window.location.pathname);
});


}

if(document.querySelector(".add-to-cart-btn") !== null) {
  
document.querySelector(".add-to-cart-btn").addEventListener("click", () => {

  document.querySelector(".sideaddtocartitem").style.setProperty("display", "none");

  let settrashinterval = setInterval(() => {
    
    if(document.querySelector(".opencarttrash")) {
    document.querySelector(".opencarttrash").addEventListener("click", () => {
      setTimeout(() => {

          document.querySelector(".sideaddtocartitem").style.setProperty("display", "block");
        
      }, 1000) 
	}) }
    
  }, 100)

  setTimeout(() => {
    clearInterval(settrashinterval);
  },5000)
  
})

}

if(document.querySelector("li:has(a[href*='early-adaptors-smartwatch'])")) {
  document.querySelector("li:has(a[href*='early-adaptors-smartwatch'])").remove();
}

if(document.querySelector("li:has(a[href*='for-test'])")) {
  document.querySelector("li:has(a[href*='for-test'])").remove();
}


if(document.querySelector("ul[data-alltags]")) {

let customtags = JSON.parse(document.querySelector("ul[data-alltags]").dataset.alltags);

customtags.unshift("All");

customtags.forEach((i, index) => {
	
	let newlabel = document.createElement("label");
	newlabel.setAttribute("for", i+index);
	newlabel.innerText = i;
	
	let newcheckbox = document.createElement("input");
	newcheckbox.type = "checkbox";
	newcheckbox.value = i;
	newcheckbox.id = i+index;
	
	document.querySelector(".newtabs").append(newcheckbox, newlabel)
})

var checkboxes = document.querySelectorAll(".newtabs input");
var checkedItems = [];

document.getElementById("All0").checked = true;

let initpostnumber = 9;
	
checkboxes.forEach(function(checkbox) {
  checkbox.addEventListener("change", function() {
  	initpostnumber = 9;

    if (checkbox.checked) {
      checkedItems.push(checkbox.value);
    } else {
      var index = checkedItems.indexOf(checkbox.value);
      if (index !== -1) {
        checkedItems.splice(index, 1);
      }
    }

    document.querySelectorAll(".news-contents-li").forEach((i, index) => {
    	
    	    function containsWordFromArray(sentence, wordArray) {
			  for (var i = 0; i < wordArray.length; i++) {
			    var word = wordArray[i];
			    if (sentence.includes(word)) {
			      return true;
			    }
			  }
			  return false;
			}

			var sentence = i.dataset.tag.split(/(?=[A-Z])/).join(" ");
			var wordArray = checkedItems.map(element => element.split(' ')[0]);
      
			if (containsWordFromArray(sentence, wordArray)) {
			  i.style.display = "block";
			  i.classList.add("filteredlists");
			} else {
			  i.style.display = "none";
			  i.classList.remove("filteredlists");
			}
	})
	
	if(checkedItems.length < 1) {
		document.getElementById("All0").checked = true;
		document.querySelectorAll(".news-contents-li").forEach((item, index) => {
			if(index < 6) {
			item.style.display = "block";
			}
		})
	} else {
		document.getElementById("All0").checked = false;
	}
	
	document.querySelectorAll(".filteredlists").forEach((item, index) => {
		if(index > 5) {
			item.style.display = "none";
		}
	})
    
  });
});

// 

if(document.querySelector('.news') !== null) {
	
	let loadmorebtn = document.createElement("button");
	loadmorebtn.innerText = "Load More";
	loadmorebtn.classList.add("loadmorebtn");
	loadmorebtn.classList.add("updated");
	loadmorebtn.addEventListener("click", () => {
		
		if(document.getElementById("All0").checked) {
		
		document.querySelectorAll('.news-contents-li').forEach((i, index) => {
			if(index < initpostnumber){
				setTimeout(function() {
					i.style.setProperty("display", "block", "important")
				}, 300);
			}
		})
		
		} else {
		
		document.querySelectorAll('.filteredlists').forEach((i, index) => {
			if(index < initpostnumber){
				setTimeout(function() {
					i.style.setProperty("display", "block", "important")
				}, 300);
			}
		})
		
		}
		
		initpostnumber += 3;
	})
	
	document.querySelector('.news').append(loadmorebtn)
}


let foundxpost = document.createElement("p");
foundxpost.innerText = `Found ${document.querySelectorAll('.news-contents-li').length} posts`;

Array.from(document.querySelectorAll('.newtabs input')).slice(1).forEach((inputcheck) => {
	inputcheck.addEventListener("change", (e) => {
	foundxpost.innerText = `Found ${document.querySelectorAll('.filteredlists').length} posts`;

    if(document.querySelector('#All0').checked) {
      foundxpost.innerText = `Found ${document.querySelectorAll('.news-contents-li').length} posts`;
    }

    if(Array.from(document.querySelectorAll('.newtabs input')).slice(1).some((i) => i.checked)) {
    document.querySelector("#All0").disabled = true;
    } else {
        document.querySelector("#All0").disabled = false;
    }
})
})
  
let blogpostname = document.createElement("p");
blogpostname.innerText = "All Posts";
  
let blogbreadcrumbs = document.createElement("p");
let blogbreadcrumbshome = document.createElement("span");
blogbreadcrumbs.innerText = `Home${window.location.pathname.split("/").join(" | ").slice(0)}`;

document.querySelector(".blogsinfos").append(blogbreadcrumbs, blogpostname, foundxpost);
}

document.addEventListener('DOMContentLoaded', function() {

setTimeout(function() {
  document.querySelectorAll('.opencarttrash').forEach((i) => {
    i.addEventListener("click", () => {
      
      setTimeout(() => {
              document.querySelector('.sideaddtocartitem').classList.remove("hidesideaddtocartitem");
      }, 1000)
          
      })
  })
  
}, 1000);
  
});

document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector("body.product-product-template #MainContent > div[id*='__main']") !== null) {
    
  if (window.innerWidth < 1024) {
    
  setTimeout(() => {
    document.querySelectorAll(".splide__arrow").forEach((i) => {
    i.addEventListener("click", () => {
        setTimeout(() => {
                  document.querySelector("body.product-product-template #MainContent > div[id*='__main'] .product-content .product-block-text:first-child").click();
              }, 3000)
          })
      })
  }, 2000)

  }

  }
});

document.addEventListener('DOMContentLoaded', function() {

  if(document.querySelector("body.product-product-template #MainContent > div[id*='__main'] div[id*='__main']") !== null) {
  
  setTimeout(function() {
    if (window.innerWidth > 1024) {
      new Splide("body.product-product-template #MainContent > div[id*='__main'] div[id*='__main']", {
        type: 'slide',
        perPage: 1,
        pagination: true,
        arrows: true,
      }).mount();

      document.querySelectorAll('.splide__pagination li button').forEach(function(item, index) {
        item.addEventListener('click', function() {
          document.querySelectorAll('.col-span-full.hidden .product-thumbnail-list-item a')[index].click();
        });
      });
    }
    
      let splidePaginationBtnD = document.querySelectorAll(".splide__pagination li button");
      let currentIndex = 0;

      function simulateButtonClick() {
        
        currentIndex++;

        if (currentIndex >= splidePaginationBtnD.length) {
          currentIndex = 0;
        }

        splidePaginationBtnD[currentIndex].click();
      }

      function simulateButtonClickBack() {
  
            currentIndex--;
            
            if (currentIndex < 0) {
              currentIndex = splidePaginationBtnD.length - 1;
            }           

          splidePaginationBtnD[currentIndex].click();
            
      }

  
      let productSliderDesk = setInterval(simulateButtonClick, 2500);

      if(document.querySelector("body.product-product-template #MainContent > div[id*='__main'] button") !== null) {

          function clickedcheck(e) {
            if(e.target.hasAttribute('@click') && e.target.getAttribute('@click') === "changeMedia('next')") {
              simulateButtonClick()
            } 

            if(e.target.hasAttribute('@click') && e.target.getAttribute('@click') === "changeMedia('prev')") {
              simulateButtonClickBack()
            } 
          }
        
        document.querySelectorAll("body.product-product-template #MainContent > div[id*='__main'] .splide").forEach((i) => {
          i.addEventListener("mouseenter", () => {
            clearInterval(productSliderDesk);
              i.addEventListener("click", clickedcheck)
          })

          i.addEventListener("mouseleave", () => {
            i.removeEventListener("click", clickedcheck)
            // productSliderDesk = setInterval(simulateButtonClick, 2500);
          })
        })
      }
      
  }, 1000);

}
                          
});

if(document.querySelectorAll(".events_cta button") !== null) {
  document.querySelectorAll(".events_cta button").forEach((i) => {
  	if(i.dataset.klaviyo !== undefined) {
  		i.addEventListener("click", () => {
  			  window._klOnsite = window._klOnsite || [];
  			  window._klOnsite.push(['openForm', i.dataset.klaviyo]);
  		})
  	}
  })
}



// document.addEventListener('DOMContentLoaded', function() {
//   if(document.querySelector("#slideshow-template--20206203928890__main") !== null) {
//   setTimeout(function() {
//     if (window.innerWidth > 1024) {
//       new Splide('#slideshow-template--20206203928890__main', {
//         type: 'slide',
//         perPage: 1,
//         pagination: true,
//         arrows: false,
//       }).mount();

//       document.querySelectorAll('.splide__pagination li button').forEach(function(item, index) {
//         item.addEventListener('click', function() {
//             document.querySelectorAll('.col-span-full.hidden .product-thumbnail-list-item a')[index].click();
//         });
//       });
//     }
    
//       let splidePaginationBtnD = document.querySelectorAll(".splide__pagination li button");
//       let currentIndex = 0;

//       function simulateButtonClick() {
        
//         currentIndex++;

//         if (currentIndex >= splidePaginationBtnD.length) {
//           currentIndex = 0;
//         }

//          if(getComputedStyle(document.querySelector('div[data-header-search]')).display === 'none') {
//         splidePaginationBtnD[currentIndex].click();
//          }
//       }

//       function simulateButtonClickBack() {
  
//             currentIndex--;
            
//             if (currentIndex < 0) {
//               currentIndex = splidePaginationBtnD.length - 1;
//             }           

//           splidePaginationBtnD[currentIndex].click();
            
//       }

  
//       let productSliderDesk = setInterval(simulateButtonClick, 2500);

//       if(document.querySelector("#shopify-section-template--20206203928890__main button") !== null) {

//           function clickedcheck(e) {
//             if(e.target.hasAttribute('@click') && e.target.getAttribute('@click') === "changeMedia('next')") {
//               simulateButtonClick()
//             } 

//             if(e.target.hasAttribute('@click') && e.target.getAttribute('@click') === "changeMedia('prev')") {
//               simulateButtonClickBack()
//             } 
//           }
        
//         document.querySelectorAll("#shopify-section-template--20206203928890__main .splide").forEach((i) => {
//           i.addEventListener("mouseenter", () => {
//             clearInterval(productSliderDesk);
//               i.addEventListener("click", clickedcheck)
//           })

//           i.addEventListener("mouseleave", () => {
//             i.removeEventListener("click", clickedcheck)
//             productSliderDesk = setInterval(simulateButtonClick, 2500);
//           })
//         })
//       }
      
//   }, 1000);
//   };
// });

if(document.querySelector("div[id*='__3f5df025-4792-44cf-921b-1727176e118e'] a") !== null){
  document.querySelector("div[id*='__3f5df025-4792-44cf-921b-1727176e118e'] a").target = "_blank";
}

if(document.querySelector("div[id*='__8b1fe1d7-5bfd-4d32-8865-8716de2d9536'] a") !== null){
  document.querySelector("div[id*='__8b1fe1d7-5bfd-4d32-8865-8716de2d9536'] a").target = "_blank";
}

document.querySelector("#shopify-section-footer li:nth-child(5) a").target = "_blank";
document.querySelector("#shopify-section-footer li:nth-child(5) a").rel = "nofollow";

// 

if(document.querySelector('.home_new_slides .swiper-wrapper')) {
  const parentWrapper = document.querySelector('.home_new_slides .swiper-wrapper');
  const childElements = parentWrapper.children;
  
  for (let i = 0; i < 2; i++) {
    Array.from(childElements).forEach(element => parentWrapper.appendChild(element.cloneNode(true)));
  }
}

let home_new_slides = new Swiper('#home_new_slides', {
      lazy: false,
      slidesPerView: 'auto',
      loop: true,
      centeredSlides: true,
      spaceBetween: 50,
      observer: true, 
      observeParents: true,
      navigation: {
        nextEl: '.swiper-button-nextx',
        prevEl: '.swiper-button-prevx',
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
        },
        1300: {
          slidesPerView: 5,
        },
        1500: {
        slidesPerView: "auto",
        },
      },
      autoplay: {
        delay: 2000, 
        disableOnInteraction: false,  
      },
  allowTouchMove: false,
  on: {
    slideChange: function () {


if (window.innerWidth <= 768) {

const targetElement = document.querySelector('.Homepage main .shopify-section:nth-child(10) > section');
  
if (targetElement) {
  function getRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
  }
  
  const angle = getRandomNumber(160, 200);
  
  const gradient = `linear-gradient(${angle}deg, rgba(255, 255, 255, 0.00) 18.69%, #82cfff 47.46%)`;
  targetElement.style.background = gradient;
}

}

    }
  }
});  

if(document.querySelector('#home_new_slides')) {
    home_new_slides.el.addEventListener('mouseenter', function () {
    home_new_slides.autoplay.stop();
  });
  
  home_new_slides.el.addEventListener('mouseleave', function () {
    home_new_slides.autoplay.start();
  });
}




function setHeaderBackgroundColor() {
  if (isMobileView()) {
    if (document.querySelector('body.Home header')) {
      if (window.scrollY > (window.innerHeight - 120)) {
        document.querySelector('body.Home header').style.backgroundColor = '#5B6770';
      } else {
        document.querySelector('body.Home header').style.backgroundColor = 'transparent';
      }
    }
  } else {
    if (document.querySelector('body.Home header')) {
      if (window.scrollY > 50) {
        document.querySelector('body.Home header').style.backgroundColor = '#5B6770';
      } else {
        document.querySelector('body.Home header').style.backgroundColor = 'transparent';
      }
    }
  }
}

function isMobileView() {
  return window.innerWidth <= 768; // Adjust the threshold as per your design's mobile breakpoint
}


// Call the function on scroll
window.addEventListener('scroll', setHeaderBackgroundColor);

// Call the function on window resize
window.addEventListener('resize', setHeaderBackgroundColor);


if(document.querySelector('body.Home header')) {

window.addEventListener('load', setHeaderBackgroundColor);
window.addEventListener('scroll', setHeaderBackgroundColor);
  
}

if(document.querySelectorAll(".home_new_slide img")) {

document.querySelectorAll(".home_new_slide img").forEach(function (slide) {
    var randomRotation = Math.floor(Math.random() * 31) - 15;

    if (randomRotation === -15) {
        slide.style.transform = "rotate(" + randomRotation + "deg) translateX(-15px) translateY(-15px)";
    } else {
        slide.style.transform = "rotate(" + randomRotation + "deg)";
    }
});

const slides = document.querySelectorAll('.home_new_slide');

let resetTimeout;

function applyRandomTransform() {
  slides.forEach(slide => {
    const randomTranslateY = Math.random() * (-20);
    slide.style.transition = 'transform 0.5s'; 
    slide.style.transform = `translateY(${randomTranslateY}px)`;
  });
}

function resetTransform() {
  slides.forEach(slide => {
    slide.style.transition = 'transform 0.5s';
    slide.style.transform = 'translateY(0px)';
  });
}


}


if (window.innerWidth < 1024) {
    var liElement = document.createElement("li");
    liElement.innerHTML = '<a href="/account/login">Sign in</a>';

    var menu0Ul = document.querySelector("#menu0 ul");
    menu0Ul.appendChild(liElement);
}


if (window.innerWidth < 800 && document.querySelector('body.product-product-template')) {
    var elementToCopy1 = document.querySelector('body.product-product-template #MainContent .product-content .product-block-text:nth-child(1)');
    var elementToCopy2 = document.querySelector('body.product-product-template #MainContent .product-content .product-block-text:nth-child(2)');
    var elementToCopy3 = document.querySelector('body.product-product-template #MainContent .product-content .product-block-text:nth-child(3)'); 
    var priceElement = document.querySelector('body.product-product-template #MainContent > .shopify-section:nth-child(2) .product-block-price');
    var targetElement = document.querySelector('body.product-product-template #MainContent > .shopify-section:nth-child(2) .grid');

    if (elementToCopy1 && elementToCopy2 && elementToCopy3 && priceElement && targetElement) {
        var appendedProductsDiv = document.createElement('div');
        appendedProductsDiv.className = 'appended_products_content_mobile';

        var clonedElement1 = elementToCopy1.cloneNode(true);
        elementToCopy1.style.display = "none";
        appendedProductsDiv.appendChild(clonedElement1);

        var clonedElement2 = elementToCopy2.cloneNode(true);
        elementToCopy2.style.display = "none";
        appendedProductsDiv.appendChild(clonedElement2);

        var clonedElement3 = elementToCopy3.cloneNode(true); // Clone the third element
        elementToCopy3.style.display = "none";
        appendedProductsDiv.appendChild(clonedElement3);

        var clonedPriceElement = priceElement.cloneNode(true);
        priceElement.style.display = "none";
        appendedProductsDiv.appendChild(clonedPriceElement);

        targetElement.insertBefore(appendedProductsDiv, targetElement.firstChild);
    }

    document.querySelector("body.product-product-template #MainContent>.shopify-section:nth-child(7) .healthy_nutrition")
        .prepend(document.querySelector("body.product-product-template #MainContent>.shopify-section:nth-child(7) .healthy_content h2").cloneNode(true));
}


document.querySelector('form[role="search"] button:last-child').addEventListener("click", () => {
  document.querySelector("body").click();
})

window.addEventListener('scroll', function() {
    document.querySelector('form[role="search"] button:last-child').click();
});

if(document.querySelectorAll('body.Safety.page-safety a')) {
  document.querySelectorAll('body.Safety.page-safety a').forEach(function(link) {
      if (!link.href.includes("littleone.care")) {
          link.setAttribute('target', '_blank');
      }
  });
}

if (typeof InstallTrigger !== 'undefined') {
  const shopifySections = document.querySelectorAll(".shopify-section");

  if (window.innerWidth >= 1024) {
    shopifySections.forEach(shopifySection => {

      const hasSwiperWrapper = shopifySection.querySelector(".swiper-wrapper");

      if (hasSwiperWrapper) {
        shopifySection.style.setProperty("zoom", "1", "important");
        shopifySection.style.setProperty("transform", "scale(.8)", "important");
        shopifySection.style.setProperty("transform-origin", "top left", "important");
        shopifySection.style.setProperty("width", "125%", "important");
        shopifySection.style.setProperty("height", "125%", "important");
      }
    });
  }
}

if (typeof InstallTrigger !== 'undefined') {
  if (window.innerWidth >= 1024) {
    document.querySelector("#shopify-section-littleone-announcement-bar").style.marginBottom = "-14px";
    if(document.querySelector("#shopify-section-template--22828594987322__custom_liquid_6XmNr6")) {
      document.querySelector("#shopify-section-template--22828594987322__custom_liquid_6XmNr6").style.marginBottom = "-200px";
    }
    if(document.querySelector("#shopify-section-template--22869157871930__custom_liquid_ffE7Gd")) {
      document.querySelector("#shopify-section-template--22869157871930__custom_liquid_ffE7Gd").style.marginBottom = "-200px";
    }

    if(document.querySelector("#shopify-section-template--22854444417338__custom_liquid_c7QqKX")) {
      document.querySelector("#shopify-section-template--22854444417338__custom_liquid_c7QqKX").style.marginBottom = "-230px";
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("shopify-section-template--22852565172538__26607154-8bcf-4cea-a517-b5d5c50f6cb2") || document.getElementById("shopify-section-template--22852565172538__45379f21-79d8-40cc-b08c-8eeba20f3f33") || document.getElementById("shopify-section-template--22852565172538__text_columns_with_images_K3dtzP")) {
        fetch("https://ipapi.co/json/")
            .then(r => r.json())
            .then(d => {
                if (d.country_code === "IL") {
                    if (document.getElementById("shopify-section-template--22852565172538__26607154-8bcf-4cea-a517-b5d5c50f6cb2")) document.getElementById("shopify-section-template--22852565172538__26607154-8bcf-4cea-a517-b5d5c50f6cb2").style.display = "block";
                    if (document.getElementById("shopify-section-template--22852565172538__45379f21-79d8-40cc-b08c-8eeba20f3f33")) document.getElementById("shopify-section-template--22852565172538__45379f21-79d8-40cc-b08c-8eeba20f3f33").style.display = "block";
                    if (document.getElementById("shopify-section-template--22852565172538__text_columns_with_images_K3dtzP")) document.getElementById("shopify-section-template--22852565172538__text_columns_with_images_K3dtzP").style.display = "block";
                }
            });
    }
});

document.addEventListener("DOMContentLoaded", () => {
  const img = document.querySelector("#shopify-section-template--22828594987322__image_with_text_overlay_PArHjt .image-wrapper img");
  if (img) {
    img.style.cursor = "pointer";
    img.onclick = () => window.open("https://www.prnewswire.com/news-releases/the-moms-choice-awards-names-ai-powered-pregnancy--baby-wellness-wearable-elora-among-the-best-in-family-friendly-products-302411114.html", "_blank");
  }
});
